import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Progress/progress';
import { css } from '@patternfly/react-styles';
export var ProgressBar = function ProgressBar(_a) {
  var progressBarAriaProps = _a.progressBarAriaProps,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      value = _a.value,
      props = __rest(_a, ["progressBarAriaProps", "className", "children", "value"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.progressBar, className)
  }, progressBarAriaProps), React.createElement("div", {
    className: css(styles.progressIndicator),
    style: {
      width: "".concat(value, "%")
    }
  }, React.createElement("span", {
    className: css(styles.progressMeasure)
  }, children)));
};